export default __webpack_public_path__ + "static/media/angers2.cbcde1f2.jpg";